import { multiTenantRoles, roleNames } from '../constants/userRoles';

const allSurgeonsRoles = [
  roleNames.SALES_REP,
  roleNames.EXTERNAL_SALES_REP,
  roleNames.PRACTICE_MANAGER,
];

const surgeonScopedRoles = [
  ...allSurgeonsRoles,
  roleNames.SURGEON,
];

const hasAllSurgeonsAccess = (user) => {
  return allSurgeonsRoles.includes(user?.role) && !!user?.allSurgeons;
};

const hasSurgeonScope = (user) => {
  return surgeonScopedRoles.includes(user?.role);
};

const canAccessSurgeon = (user, surgeonId) => {
  return hasAllSurgeonsAccess(user) || user?.assignedSurgeons?.includes(surgeonId);
};

const isAssigned = (user, surgeons) => {
  if (!user || !surgeons) {
    return false;
  }

  if (hasAllSurgeonsAccess(user)) {
    return true;
  }

  const { role, assignedSurgeons } = user;

  if (!assignedSurgeons) {
    return false;
  }

  const filteredSurgeons = assignedSurgeons.filter((surgeon) => !!surgeons.find((item) => item.id === surgeon));

  return [...multiTenantRoles, roleNames.SALES_REP].includes(role) && !!filteredSurgeons.length;
};

export {
  isAssigned,
  hasAllSurgeonsAccess,
  hasSurgeonScope,
  canAccessSurgeon,
  allSurgeonsRoles,
}
